require("../contacts-content/contacts-content");

const adminRoot = document.querySelector("[data-admin-root]");

const MAX_REQUISITES_BYTES = 1.5 * 1024 * 1024;
const ALLOWED_REQUISITES_EXT = /\.(pdf|doc|docx|xls|xlsx|rtf)$/i;

function initAdminContactsContent() {
  const store = window.NMContactsContent;
  if (!store || !adminRoot || window.NMAdminContactsContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');
  const contactsForm = document.querySelector("[data-contacts-form]");
  const contactsNote = document.querySelector("[data-contacts-note]");
  const requisitesFileInput = document.querySelector("#contacts-requisites-file");
  const requisitesDataInput = document.querySelector("[data-contacts-requisites-data]");
  const requisitesNameInput = document.querySelector("[data-contacts-requisites-name]");
  const requisitesPreview = document.querySelector("[data-contacts-requisites-preview]");
  const requisitesFilename = document.querySelector("[data-contacts-requisites-filename]");
  const requisitesReset = document.querySelector("[data-contacts-requisites-reset]");

  const REQUIRED_FIELDS = [
    "title",
    "description",
    "email",
    "addressLabel",
    "address",
    "scheduleLabel",
    "workdaysTitle",
    "workdaysTime",
    "weekendsTitle",
    "weekendsTime",
    "salesLabel",
    "salesPhone",
    "logisticsLabel",
    "logisticsPhone",
    "emailLabel",
    "requisitesText",
    "mapX",
    "mapY",
    "mapZoom",
  ];

  let noteTimer = null;

  function showNote() {
    if (!contactsNote) return;
    contactsNote.hidden = false;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(() => {
      contactsNote.hidden = true;
    }, 2200);
  }

  function clearContactsErrors() {
    contactsForm?.querySelectorAll("[data-contacts-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-contacts-error]");
      if (error) error.hidden = true;
    });
  }

  function showContactsError(name) {
    const field = contactsForm?.querySelector(`[data-contacts-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-contacts-error]");
    if (error) error.hidden = false;
  }

  function updateRequisitesPreview(url, fileName) {
    const hasFile = Boolean(url && url !== "#");
    if (requisitesDataInput) requisitesDataInput.value = hasFile ? url : "";
    if (requisitesNameInput) requisitesNameInput.value = hasFile ? (fileName || "") : "";
    if (requisitesFilename) {
      requisitesFilename.textContent = hasFile
        ? (fileName || "Файл прикреплён")
        : "";
    }
    if (requisitesPreview) requisitesPreview.hidden = !hasFile;
  }

  function clearRequisitesFile() {
    if (requisitesFileInput) requisitesFileInput.value = "";
    updateRequisitesPreview("", "");
  }

  function fillContactsForm() {
    if (!contactsForm) return;
    const data = store.getContactsData();
    Object.keys(data).forEach((key) => {
      if (key === "requisitesUrl" || key === "requisitesFileName") return;
      const input = contactsForm.elements[key];
      if (input) input.value = data[key] || "";
    });
    if (requisitesFileInput) requisitesFileInput.value = "";
    updateRequisitesPreview(data.requisitesUrl, data.requisitesFileName);
    if (contactsNote) contactsNote.hidden = true;
    clearContactsErrors();
  }

  function showContactsEditor() {
    if (contentHome) contentHome.hidden = true;
    if (aboutEditor) aboutEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    const articlesEditor = document.querySelector('[data-content-editor="articles"]');
    const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = false;
    fillContactsForm();
  }

  function readField(formData, name) {
    return String(formData.get(name) || "").trim();
  }

  function handleContactsSubmit(event) {
    event.preventDefault();
    clearContactsErrors();

    const formData = new FormData(contactsForm);
    const defaults = store.getDefaultData();
    const payload = { ...defaults };

    Object.keys(defaults).forEach((key) => {
      if (key === "requisitesUrl" || key === "requisitesFileName") return;
      payload[key] = readField(formData, key);
    });

    const requisitesUrl = readField(formData, "requisitesUrl");
    const requisitesFileName = readField(formData, "requisitesFileName");
    payload.requisitesUrl = requisitesUrl || "#";
    payload.requisitesFileName = requisitesUrl && requisitesUrl !== "#" ? requisitesFileName : "";

    let hasError = false;
    REQUIRED_FIELDS.forEach((name) => {
      if (!payload[name]) {
        showContactsError(name);
        hasError = true;
      }
    });
    if (hasError) return;

    try {
      store.saveContactsData(payload);
      showNote();
    } catch (error) {
      showContactsError("requisitesFile");
    }
  }

  document.querySelectorAll('[data-content-open="contacts"]').forEach((button) => {
    button.addEventListener("click", showContactsEditor);
  });

  if (contactsForm) {
    contactsForm.addEventListener("submit", handleContactsSubmit);
    contactsForm.querySelectorAll("input, textarea").forEach((input) => {
      if (input.type === "file" || input.type === "hidden") return;
      input.addEventListener("input", () => {
        const field = input.closest("[data-contacts-field]");
        if (!field) return;
        field.classList.remove("has-error");
        const error = field.querySelector("[data-contacts-error]");
        if (error) error.hidden = true;
      });
    });
  }

  if (requisitesFileInput) {
    requisitesFileInput.addEventListener("change", () => {
      const file = requisitesFileInput.files?.[0];
      if (!file) return;

      const field = requisitesFileInput.closest("[data-contacts-field]");
      if (field) {
        field.classList.remove("has-error");
        const error = field.querySelector("[data-contacts-error]");
        if (error) error.hidden = true;
      }

      if (!ALLOWED_REQUISITES_EXT.test(file.name) || file.size > MAX_REQUISITES_BYTES) {
        clearRequisitesFile();
        showContactsError("requisitesFile");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        updateRequisitesPreview(String(reader.result || ""), file.name);
      };
      reader.onerror = () => {
        clearRequisitesFile();
        showContactsError("requisitesFile");
      };
      reader.readAsDataURL(file);
    });
  }

  if (requisitesReset) {
    requisitesReset.addEventListener("click", () => {
      clearRequisitesFile();
    });
  }

  window.NMAdminContactsContent = {
    showContactsEditor,
  };
}

if (adminRoot) {
  initAdminContactsContent();
  window.setTimeout(initAdminContactsContent, 0);
}
